import { dateFilter, permissionPresets, services } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ dateFilter ],

  computed: {
    hasPermissions() {
      return this.checkPermissions(`advanced.${services.users}.get`, permissionPresets.resellerUp)
    },

    flagsIsDefault() {
      return this.proxy.isActive && !this.proxy.isBlocked
    }
  },

  methods: {
    clearFlags() {
      this.proxy.isActive = true
      this.proxy.isBlocked = false
    }
  },

  render
}
